<h3 class="text-center" style="color: #5A1727">Reducción IVA al 4%.</h3>
<mat-horizontal-stepper linear #stepper>
  <mat-step [stepControl]="datosVehiculos" [editable]="isEditable">
    <ng-template matStepLabel>Vehículo</ng-template>
    <form [formGroup]="datosVehiculos" autocomplete="off" (ngSubmit)="siguiente()">
      <h3 class="text-left" style="color: #5A1727">Datos Básicos</h3>
      <hr>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Tipo Vehículo</mat-label>
        <select matInput matNativeControl formControlName="tipoVehiculo" required>
          <option label="--Seleccionar--"></option>
          <option value="00 - CAMION">00 - CAMION</option>
          <option value="02 - CAMION CAJA">02 - CAMION CAJA</option>
          <option value="03 - CAMION FURGON">03 - CAMION FURGON</option>
          <option value="08 - CAMION TALLER">08 - CAMION TALLER</option>
          <option value="20 - FURGONETA">20 - FURGONETA</option>
          <option value="25 - TODO TERRENO">25 - TODO TERRENO</option>
          <option value="40 - TURISMO">40 - TURISMO</option>
          <option value="50 - MOTOCICLETA DE 2 RUEDAS SIN SIDECAR">50 - MOTOCICLETA DE 2 RUEDAS SIN SIDECAR</option>
          <option value="70 - VEHICULO ESPECIAL">70 - VEHICULO ESPECIAL</option>
          <option value="73 - CARRETILLA ELEVADORA">73 - CARRETILLA ELEVADORA</option>
          <option value="0G - VEHICULO MIXTO ADAPTABLE">0G - VEHICULO MIXTO ADAPTABLE</option>
          <option value="90 - CICLOMOTOR">90 - CICLOMOTOR</option>
        </select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Nº Bastidor(E)</mat-label>
        <input matInput matNativeControl type="text" formControlName="bastidor" onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Marca</mat-label>
        <input matInput matNativeControl type="text" formControlName="marca">
      </mat-form-field>


      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Modelo</mat-label>
        <input matInput matNativeControl type="text" formControlName="modelo">
      </mat-form-field>

      <div class="text-center mt-5">
        <button type="submit" mat-button class="btn-secondary" matStepperNext>Siguiente</button>
      </div>

    </form>
  </mat-step>
  <mat-step [stepControl]="(datosCliente | async)" [editable]="isEditable">
    <ng-template matStepLabel>Cliente</ng-template>
    <app-cliente #clienteComponent (datoCliente)="siguiente2($event)"></app-cliente>
  </mat-step>

  <mat-step [stepControl]="documentos" [editable]="isEditable">
    <ng-template matStepLabel>Documentos</ng-template>
    <app-documentos [datoTramite]="DatoCliente"></app-documentos>
  </mat-step>
</mat-horizontal-stepper>
